import { FormBuilder, FormGroup, Validators, FormControl, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ToastService } from 'src/app/services/toast/toast.service';
import { CanDeactivate, Router } from '@angular/router';
import { EmptyKeyValue, KeyValue } from 'src/app/models/key-value';
import messagesJson from 'src/assets/messages/documentation-reports.json';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'vex-receivers-dialog',
  templateUrl: './receivers-dialog.component.html',
  styleUrls: ['./receivers-dialog.component.scss']
})
export class ReceiversDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
    public dialog: MatDialogRef<ReceiversDialogComponent>,
    private router: Router,
    private fb: FormBuilder,
    private alert: ToastService) { }
  
  
  form: FormGroup;
  contacts: Array<any>;
  client: Array<any>;
  broker: Array<any>;
  user: string;
  userContact: string = '';
  clientLanguage: string = '';
  clientMessage: { language: string; message: string };
  languages: string[] = [];
  brokerList: Array<KeyValue>;
  
  messages = messagesJson.messages;
  
  ngOnInit() {

    this.contacts = this.defaults.data?.client || this.defaults.client;
    this.client = this.defaults.data?.client || this.defaults.client;
    this.broker = this.defaults.data?.broker || this.defaults.broker;
    this.user = this.defaults.data?.user || this.defaults.user;

    this.clientLanguage = this.contacts[0]?.language?.name || 'en';

    this.clientMessage = this.messages.find(
      msg => msg.language === this.clientLanguage
    );

    if (!this.clientMessage) {
      this.clientMessage = { language: 'en', message: '' };
    }

    this.loadForm();
    this.replaceTracking();
  }

  replaceTracking() {

    this.clientMessage = this.messages.find(
      msg => msg.language === this.clientLanguage
    );

    let message = this.clientMessage.message.replace('{tracking}', this.defaults.tracking ?? null);

    this.form.patchValue({
      sendMessage: message,
    });
  }

  loadForm() {
    this.form = this.fb.group({
      user: this.user,
      receiver: this.client[0]?.email,
      sendMessage: this.clientMessage.message,
    });
  }

  changeReceiver(check: boolean) {
    if (check) {
      if (this.broker.length > 0) {
        this.form.get('receiver').setValue(this.broker[0].email);
        this.contacts = this.broker;

      } else {
        this.form.get('receiver').setValue(null);
        this.contacts = this.brokerList;
      }
    } else {
      this.form.get('receiver').setValue(this.client[0].email);
      this.contacts = this.client;
    }

    this.clientLanguage = this.contacts[0]?.language?.name || 'en';

    this.clientMessage = this.messages.find(
      msg => msg.language === this.clientLanguage
    );
  }

  closeDialog(): void {
    this.dialog.close('');
  }

  send(): void {
    this.form.get('sendMessage').setValue(this.form.get('sendMessage').value.replace(/\n/g, "<br>"));
    this.form.value.language = this.clientLanguage;
    this.dialog.close(this.form.value);
  }
  
}
